import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
  selector: 'gf-card',
  template: require('./gf-card.component.html')
})
export class GfCardComponent {
  @Input() card: any;
  @Input() col: any;
  @Input() row: any;
  @Input() boardOptions: any;
  @Input() readonly: boolean = false;
  @Input() onEditItem;
  @Input() onMenuClick;

  constructor(private stateService: StateService) {
  }

  ngOnInit(): void {
  }

  onEdit(card: any) {
    if (typeof this.onEditItem === 'function') {
      this.onEditItem(card);
    }
  }

  onContextMenuClick() {
    return (params) => {
      if (typeof this.onMenuClick === 'function') {
        if (!_.has(params, 'row')) {
          params.row = this.row;
        }
  
        if (!_.has(params, 'col')) {
          params.col = this.col;
        }
  
        this.onMenuClick(params);
      }
    }
  }

  hrefForRoute(route: string, params?: any) {
    return this.stateService.go(route, params);
  }
}
